import React from 'react'
import ReactDOM from 'react-dom'
import Root from './core/Root'
import './index.css'

ReactDOM.render(<Root />, document.getElementById('root'))

// @ts-ignore Add store on window when running e2e tests
// if (window.Cypress) window.store = store
